import React from "react";
import { Box } from "@mui/material";
import ActivitiesCompleted from "../../ActivitiesCompleted/ActivitiesCompleted";
import ProgressBar from "../../ProgressBar/ProgressBar";
import TodoItemImage from "../../TodoList/TodoItemImage";
import assignmentPic from "../../../assets/images/course_pic.png";
import LearningPathAssignmentInfo from "./LearningPathAssignmentInfo";
import { useTranslation } from "react-i18next";
import { ChangeButton } from "../../Buttons";
import { isIlt } from "../../../utils/course_utils";
import CourseActionButton from "../../Buttons/CourseActionButton";
import { courseTypes } from "../../../constants/index";

const AssignmentProgress = ({ assignment }) => {
  if (assignment.enrolledCtoaId && !assignment.totalActivities) {
    return <div />;
  }
  if (assignment.enrolledCtoaId && assignment.typeName != courseTypes.policy) {
    return (
      <Box flexDirection="column">
        <ActivitiesCompleted
          totalSteps={assignment.totalActivities}
          completedSteps={assignment.numActivitiesCompleted}
          fontSize="0.6875rem"
        />
        <Box width="100%">
          <ProgressBar
            totalSteps={assignment.totalActivities}
            completedSteps={assignment.numActivitiesCompleted}
            color="primary"
            small
          />
        </Box>
      </Box>
    );
  }
  return <div />;
};

const AssignmentActions = ({
  assignment,
  isStarted,
  onEnrolledAssignmentClick,
  onStartAssignmentClick,
  onChangeEnrollmentClick
}) => {
  const { t } = useTranslation();
  return (
    <Box display="flex" flex="0 1 141.7px" flexDirection="column">
      <CourseActionButton
        isEnrolled={!!assignment.enrolledCtoaId}
        isStarted={isStarted}
        courseType={assignment.courseType}
        onEnrollClick={() => onStartAssignmentClick(assignment)}
        onResumeCourseClick={() => onEnrolledAssignmentClick(assignment)}
        prereqs={assignment.prerequisites || []}
        startDate={assignment.enrolledTrainingObject?.zonedStartDate}
        endDate={assignment.enrolledTrainingObject?.zonedEndDate}
        iltClassType={assignment.enrolledTrainingObject?.typeName}
      />
      {assignment.versions?.length > 1 &&
        assignment.enrolledCtoaId &&
        isIlt(assignment) && (
          <ChangeButton
            key="Change Enrollment"
            text={t("learningPathListView.changeEnrollmentBtn")}
            onClick={() => onChangeEnrollmentClick(assignment)}
          />
        )}
    </Box>
  );
};

function LearningPathAssignmentsListItem({
  assignment,
  isStarted,
  onStartAssignmentClick,
  onEnrolledAssignmentClick,
  onChangeEnrollmentClick
}) {
  const assignmentType = assignment.typeName
    ? assignment.typeName.toLowerCase()
    : "";
  return assignment ? (
    <Box display="flex" flex={1} flexWrap="wrap" mb={-2} minWidth={288}>
      <Box
        display="flex"
        flex={1}
        alignItems={{ xs: "center", sm: "flex-start" }}
        pb={2}
        mr={2}
      >
        <TodoItemImage
          imageSrc={assignment.courseImage || assignmentPic}
          showAwardIncentive={assignment.showAwardIncentive}
          isNew={assignment.isNew}
        />
        <LearningPathAssignmentInfo assignment={assignment} />
      </Box>
      <Box
        display="flex"
        alignItems="center"
        mr={2}
        flex="0 1 330px"
        pb={2}
        justifyContent="space-between"
      >
        <AssignmentProgress
          assignment={assignment}
          assignmentType={assignmentType}
        />
        <AssignmentActions
          isStarted={isStarted}
          assignment={assignment}
          onEnrolledAssignmentClick={onEnrolledAssignmentClick}
          onStartAssignmentClick={onStartAssignmentClick}
          assignmentType={assignmentType}
          onChangeEnrollmentClick={onChangeEnrollmentClick}
        />
      </Box>
    </Box>
  ) : null;
}

export default LearningPathAssignmentsListItem;
